/**
 * Narrative Person (#1183). First / Close third / … on a scene.
 * Separate from Whose head. Empty means inherit book or chapter.
 */
import { POV_MODES } from './styleCardsPath';
import {
  PERSON_FROM_BOOK,
  PERSON_FROM_CHAPTER,
  PERSON_INHERITED,
  PERSON_NO_DEFAULT,
} from './writerCopy';

export const PERSON_OPTIONS = POV_MODES.filter((mode) => mode.value);

export function sectionPersonBody(povMode) {
  /** Scene override only. Never sends Whose head or clear_pov. */
  if (povMode) return { pov_mode: povMode };
  return { clear_pov_mode: true };
}

export function personModeLabel(mode) {
  if (!mode) return '';
  const found = POV_MODES.find((item) => item.value === mode);
  return found ? found.label : '';
}

export function personSelectValue(person) {
  return person?.scene_mode || '';
}

export function personInheritanceText(person) {
  /** Chip when this scene has no Person of its own. */
  if (!person || person.scene_mode) return '';
  const label = personModeLabel(person.mode) || person.mode_label || '';
  if (person.source === 'chapter' && label) return `${PERSON_FROM_CHAPTER} · ${label}`;
  if (person.source === 'book' && label) return `${PERSON_FROM_BOOK} · ${label}`;
  if (!person.mode) return PERSON_NO_DEFAULT;
  return '';
}

export function personReadout(person) {
  const own = personModeLabel(personSelectValue(person));
  if (own) return own;
  return personInheritanceText(person) || PERSON_INHERITED;
}
